import React, { useState } from 'react';
import { ExerciseLibrary } from './ExerciseLibrary';
import { SessionSetup } from './SessionSetup';
import { WorkoutPlan } from './WorkoutPlan';
import { SessionTracker } from './SessionTracker';
import { SessionSummary } from './SessionSummary';
interface GymSessionFlowProps {
  navigateTo: (screen: string) => void;
}
export const GymSessionFlow = ({
  navigateTo
}: GymSessionFlowProps) => {
  const [step, setStep] = useState(0);
  const [selectedExercises, setSelectedExercises] = useState([]);
  const [sessionData, setSessionData] = useState(null);
  const selectExercise = exercise => {
    // Check if exercise is already selected in the same slot
    const isSelected = selectedExercises.some(ex => ex.id === exercise.id && ex.slotPart === exercise.slotPart && ex.slotIndex === exercise.slotIndex);
    if (isSelected) {
      // Remove from selection
      setSelectedExercises(selectedExercises.filter(ex => !(ex.id === exercise.id && ex.slotPart === exercise.slotPart && ex.slotIndex === exercise.slotIndex)));
    } else {
      // First, remove any exercise that might be in the same slot
      const filteredExercises = selectedExercises.filter(ex => !(ex.slotPart === exercise.slotPart && ex.slotIndex === exercise.slotIndex));
      // Add to selection with defaults
      setSelectedExercises([...filteredExercises, {
        ...exercise,
        sets: 3,
        reps: 10,
        weight: 0,
        target: exercise.isCardio ? exercise.trackingType === 'calories' ? 200 : 20 : 0
      }]);
    }
  };
  const updateExercise = (index, data) => {
    const updatedExercises = [...selectedExercises];
    updatedExercises[index] = {
      ...updatedExercises[index],
      ...data
    };
    setSelectedExercises(updatedExercises);
  };
  const nextStep = () => {
    setStep(step + 1);
  };
  const prevStep = () => {
    setStep(step - 1);
  };
  const completeSession = data => {
    setSessionData(data);
    nextStep();
  };
  const renderStep = () => {
    switch (step) {
      case 0:
        return <ExerciseLibrary onBack={() => navigateTo('home')} onSelect={selectExercise} onNext={nextStep} selectedExercises={selectedExercises} data-id="element-102" />;
      case 1:
        return <SessionSetup exercises={selectedExercises} updateExercise={updateExercise} onBack={prevStep} onNext={nextStep} data-id="element-103" />;
      case 2:
        return <WorkoutPlan exercises={selectedExercises} onBack={prevStep} onStart={nextStep} data-id="element-104" />;
      case 3:
        return <SessionTracker exercises={selectedExercises} onBack={prevStep} onComplete={completeSession} data-id="element-105" />;
      case 4:
        return <SessionSummary data={sessionData} onFinish={() => navigateTo('home')} data-id="element-106" />;
      default:
        return null;
    }
  };
  return <div className="flex flex-col h-full min-h-screen" data-id="element-107">{renderStep()}</div>;
};